/**
 * Color Swatch AJAX Navigation - PDP Only
 * Handles color swatch clicks to load products without page reload
 */

/**
 * Re-executes inline scripts within an element.
 * When HTML is inserted via innerHTML/replaceWith, scripts don't execute.
 */

function executeScripts(element) {
  element.querySelectorAll('script:not([src])').forEach((oldScript) => {
    const newScript = document.createElement('script');
    Array.from(oldScript.attributes).forEach((attr) => {
      newScript.setAttribute(attr.name, attr.value);
    });
    newScript.textContent = oldScript.textContent;
    oldScript.parentNode.replaceChild(newScript, oldScript);
  });
}

document.addEventListener('click', async function(e) {
  const swatch = e.target.closest('.color-swatch-link');
  if (!swatch || swatch.classList.contains('color-swatch-current')) return;
  
  // Skip if inside quick-add modal (prevents conflicts)
  if (swatch.closest('quick-add-modal')) return;
  
  const url = swatch.dataset.url;
  if (!url) return;
  
  const currentSection = document.querySelector('section[id^="MainProduct-"]');
  if (!currentSection) {
    window.location.href = url;
    return;
  }
  
  currentSection.style.opacity = '0.5';
  currentSection.style.pointerEvents = 'none';
  
  // Extract section ID for more efficient fetch
  const sectionId = currentSection.id.replace('MainProduct-', '');
  
  try {
    // Fetch only the section instead of entire page
    const response = await fetch(`${url}?section_id=${sectionId}`);
    if (!response.ok) throw new Error('Network error');
    
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newSection = doc.querySelector('section[id^="MainProduct-"]');
    
    if (!newSection) {
      window.location.href = url;
      return;
    }
    
    currentSection.replaceWith(newSection);
    
    // Re-execute inline scripts
    executeScripts(newSection);
    
    window.Shopify?.PaymentButton?.init();
    window.ProductModel?.loadShopifyXR();
    
  } catch (error) {
    console.error('Error switching product color:', error);
    window.location.href = url;
  }
});
